module.exports = __webpack_public_path__ + "static/img/img-home-jzg-02.d39d411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-jzg-02.png
// module id = KeQn
// module chunks = 1